
  import createMeisterIcons from '../src/createMeisterIcons';

  const Shield = createMeisterIcons("shield", [["path",{"fill":"currentColor","d":"M7.5 4.25A3.26 3.26 0 0 0 4.25 7.5V12A7.743 7.743 0 0 0 12 19.75c4.186 0 7.75-3.564 7.75-7.75V7.5a3.26 3.26 0 0 0-3.25-3.25zM2.75 7.5A4.76 4.76 0 0 1 7.5 2.75h9a4.76 4.76 0 0 1 4.75 4.75V12c0 5.014-4.236 9.25-9.25 9.25A9.243 9.243 0 0 1 2.75 12z","key":"f55a88051f78d1207a71f1757721fb671f0f0dd6","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Shield
  